(() => {
  'use strict';

  const SELECTORS = { root: '[data-hood-configurator]' };
  const STORAGE_VERSION = 2;

  const OPTIONS = {
    shape: [['rectangular', 'Rettangolare'], ['round', 'Rotondo'], ['oval', 'Ovale'], ['shaped', 'Sagomato']],
    resinWood: [['olive', 'Ulivo'], ['olive-burl', 'Radica di ulivo'], ['national-walnut', 'Noce nazionale'], ['european-oak', 'Rovere Europeo'], ['ancient-beam', 'Trave secolare']],
    solidWood: [['national-walnut', 'Noce nazionale'], ['european-oak', 'Rovere Europeo'], ['wenge-oak', 'Rovere tintato wengè'], ['teak-oak', 'Rovere tintato teak'], ['ancient-beam', 'Trave secolare'], ['ash', 'Frassino'], ['elm', 'Olmo']],
    edge: [
      ['square-edge', 'Squadrati'], ['live-edge', 'Live Edge'], ['shaped-edge', 'Sagomati']
    ],
    resin: [
      ['transparent', 'Trasparente'], ['black-smoke', 'Nero fumée'], ['red-smoke', 'Rosso fumée'],
      ['blue-smoke', 'Blu fumée'], ['green-smoke', 'Verde fumée'], ['white-smoke', 'Bianco fumée'],
      ['black-mat-100', 'Nero Mat 100'], ['mica-black', 'Mica nero'], ['mica-red', 'Mica rosso'],
      ['mica-blue', 'Mica blu'], ['mica-light-blue', 'Mica azzurro'], ['mica-green', 'Mica verde'],
      ['mica-gold', 'Mica oro'], ['mica-bronze', 'Mica bronzo'], ['mica-purple', 'Mica viola'],
      ['mica-pink', 'Mica rosa'], ['mica-white', 'Mica bianco'], ['custom-resin', 'Personalizza']
    ],
    woodFinish: [
      ['natural-oil', 'Olio'], ['satin-matt', 'Opaco satinato'], ['mirror-gloss', 'Lucido a specchio']
    ],
    lacquerFinish: [
      ['satin-matt', 'Opaco satinato'], ['mirror-gloss', 'Lucido a specchio']
    ],
    model: [
      ['round-monolith', 'Tondo monolite'], ['round-iron', 'Tondo con base in ferro'],
      ['rectangular-monolith', 'Rettangolare monolite'], ['oval-iron', 'Ovale con base in ferro'],
      ['rectangular-iron', 'Rettangolare con base in ferro']
    ],
    microcementColor: [
      ['vanilla-white', 'Bianco vaniglia', '#eee9dc'], ['graphite-black', 'Nero Grafite', '#292b2a'],
      ['lime-grey', 'Grigio Calce', '#aaa69d'], ['burgundy', 'Rosso Burgundy', '#662f3a'],
      ['hermes-orange', 'Arancio Hermès', '#c86432'], ['electric-blue', 'Blu elettrico', '#175cc7'],
      ['lemon-yellow', 'Giallo limone', '#e4cf23'], ['cappuccino', 'Cappuccino', '#ad8f75'],
      ['mokka', 'Mokka', '#685044'], ['taupe', 'Taupe', '#96867a'], ['olive-green', 'Verde Oliva', '#697052'],
      ['bronze', 'Bronzo', '#80644e'], ['corten', 'Corten', '#864b35'], ['custom-color', 'Personalizza']
    ],
    lacquerColor: [
      ['ral-9010', 'RAL 9010 bianco', '#f1f0ea'], ['ral-9005', 'RAL 9005 nero', '#0a0a0a'],
      ['ral-1003', 'RAL 1003 giallo', '#f0ca00'], ['ral-2004', 'RAL 2004 arancio', '#e25303'],
      ['ral-3005', 'RAL 3005 rosso', '#5e2028'], ['ral-5003', 'RAL 5003 blu', '#1f3855'],
      ['ral-7039', 'RAL 7039 grigio', '#6b695f'], ['ral-8003', 'RAL 8003 marrone', '#7b5141'],
      ['custom-color', 'Personalizza']
    ],
    baseColor: [['base-black', 'Nero', '#111111'], ['base-white', 'Bianco', '#f4f4f1'], ['base-metal-grey', 'Grigio metallizzato', '#8d9192'], ['base-corten', 'Tinta corten', '#864b35']],
    use: [['indoor', 'Interno'], ['outdoor', 'Esterno']],
    bases: [
      { key: 'four-legs', label: 'Base a 4 zampe', price: 250 }, { key: 'base-u', label: 'Base a U', price: 250 },
      { key: 'base-v', label: 'Base a V', price: 250 }, { key: 'base-x', label: 'Base a X', price: 250 },
      { key: 'base-w', label: 'Base a W', price: 250 }, { key: 'base-spyder', label: 'Spyder', price: 350 },
      { key: 'curved-spyder', label: 'Spyder Curva', price: 400 }, { key: 'trapezoid', label: 'Trapezio', price: 500 },
      { key: 'base-scorpyo', label: 'Scorpyo', price: 600 }, { key: 'tiara', label: 'Tiara', price: 700 },
      { key: 'glass-legs', label: 'Vetro', price: 800 }, { key: 'round-central', label: 'Centrale tondo', price: 400 },
      { key: 'square-central', label: 'Centrale squadrato', price: 400 },
      { key: 'micro-cone', label: 'Base conica in microcemento', price: 400, special: 'micro' },
      { key: 'micro-cylinder', label: 'Base cilindrica in microcemento', price: 400, special: 'micro' },
      { key: 'lacquer-cone', label: 'Base conica laccata', price: 400, special: 'lacquer' },
      { key: 'lacquer-cylinder', label: 'Base cilindrica laccata', price: 400, special: 'lacquer' }
    ]
  };

  const DIMENSIONS = {
    rectangular: [['80x80','80 × 80 cm'],['80x120','80 × 120 cm'],['80x140','80 × 140 cm'],['80x160','80 × 160 cm'],['80x180','80 × 180 cm'],['90x200','90 × 200 cm'],['100x220','100 × 220 cm'],['100x240','100 × 240 cm'],['120x240','120 × 240 cm'],['120x300','120 × 300 cm']],
    round: [['d80','Diametro 80 cm'],['d90','Diametro 90 cm'],['d100','Diametro 100 cm'],['d120','Diametro 120 cm'],['d140','Diametro 140 cm'],['d160','Diametro 160 cm'],['d180','Diametro 180 cm'],['d200','Diametro 200 cm']]
  };

  const PRICE = {
    wood: { olive:500, 'olive-burl':500, 'national-walnut':300, 'european-oak':300, 'wenge-oak':300, 'teak-oak':300, 'ancient-beam':300, ash:200, elm:200 },
    finish: { 'natural-oil':500, 'satin-matt':400, 'mirror-gloss':700 },
    finishModern: { 'satin-matt':200, 'mirror-gloss':500 },
    shape: { rectangular:0, round:0, oval:200, shaped:200 },
    edge: { 'square-edge':0, 'live-edge':300, 'shaped-edge':200 },
    size: {
      'wood-resin': { '80x80':100,'80x120':200,'80x140':400,'80x160':600,'80x180':800,'90x200':1800,'100x220':2600,'100x240':3000,'120x240':3200,'120x300':4000,d80:100,d90:200,d100:400,d120:600,d140:1400,d160:1800,d180:2600,d200:3500 },
      'solid-wood': { '80x80':100,'80x120':200,'80x140':400,'80x160':600,'80x180':800,'90x200':1200,'100x220':1400,'100x240':1600,'120x240':2000,'120x300':2500,d80:100,d90:200,d100:300,d120:400,d140:700,d160:1000,d180:1400,d200:2000 },
      modern: { '80x80':100,'80x120':300,'80x140':400,'80x160':500,'80x180':600,'90x200':800,'100x220':1200,'100x240':1400,'120x240':1800,'120x300':2200,d80:100,d90:200,d100:300,d120:400,d140:700,d160:900,d180:1300,d200:1600 }
    },
    shipping: 200
  };

  const STEP_DEFINITIONS = {
    family: { title: 'Quale tavolo vuoi creare?', subtitle: 'Scegli la famiglia che più si avvicina al tuo progetto.', type: 'family', required: true },
    model: { title: 'Quale modello preferisci?', subtitle: 'Seleziona il punto di partenza del tavolo.', type: 'cards', options: 'model', required: true },
    shape: { title: 'Che forma immagini?', subtitle: 'La forma determinerà anche le dimensioni richieste.', type: 'cards', options: 'shape', required: true },
    wood: { title: 'Scegli l’essenza del legno', subtitle: 'Ogni essenza avrà venature e tonalità naturalmente uniche.', type: 'cards', options: 'wood', required: true },
    size: { title: 'Scegli le dimensioni', subtitle: 'Sono disponibili le misure previste dal listino Hood.', type: 'size', required: true },
    edge: { title: 'Come preferisci il bordo?', subtitle: 'Il bordo definisce il carattere del piano.', type: 'cards', options: 'edge', required: true },
    resin: { title: 'Scegli tipo e colore della resina', subtitle: 'La resa finale sarà verificata insieme prima della produzione.', type: 'cards', options: 'resin', required: true },
    finish: { title: 'Quale finitura preferisci?', subtitle: 'Scegli il grado di protezione e brillantezza.', type: 'finish', required: true },
    color: { title: 'Scegli il colore', subtitle: 'I colori a schermo sono indicativi.', type: 'color', required: true },
    base: { title: 'Scegli la base', subtitle: 'Mostriamo solo le basi compatibili con la configurazione corrente.', type: 'base', required: true },
    baseColor: { title: 'Scegli il colore della base', subtitle: 'La finitura della base sarà verificata prima della produzione.', type: 'baseColor', required: true },
    use: { title: 'Dove verrà utilizzato?', subtitle: 'L’uso previsto aiuta a definire il ciclo di finitura.', type: 'cards', options: 'use', required: true },
    files: { title: 'Hai immagini o disegni da condividere?', subtitle: 'Passaggio facoltativo: puoi selezionare foto, planimetrie, PDF o ispirazioni.', type: 'files', required: false },
    delivery: { title: 'Dove consegneremo il tavolo?', subtitle: 'Indica provincia o località di consegna.', type: 'text', required: true },
    final: { title: 'Ecco il tuo tavolo Hood', type: 'final', required: true }
  };

  const PATHS = {
    'wood-resin': ['family', 'shape', 'wood', 'size', 'edge', 'resin', 'finish', 'base', 'baseColor', 'files', 'delivery', 'final'],
    'solid-wood': ['family', 'shape', 'wood', 'size', 'edge', 'finish', 'base', 'baseColor', 'files', 'delivery', 'final'],
    microcement: ['family', 'model', 'shape', 'size', 'edge', 'color', 'finish', 'base', 'baseColor', 'use', 'files', 'delivery', 'final'],
    lacquered: ['family', 'shape', 'size', 'edge', 'color', 'finish', 'base', 'baseColor', 'files', 'delivery', 'final']
  };

  const LABELS = {
    family: 'Famiglia', model: 'Modello', shape: 'Forma', wood: 'Essenza', length: 'Lunghezza',
    width: 'Larghezza', diameter: 'Diametro', edge: 'Bordo', resin: 'Resina', finish: 'Finitura',
    color: 'Colore', customColor: 'Colore personalizzato', size: 'Dimensioni', base: 'Base', baseColor: 'Colore base', use: 'Utilizzo', delivery: 'Consegna', files: 'File selezionati'
  };

  class HoodConfigurator {
    constructor(root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-hood-config]').textContent);
      this.stage = root.querySelector('[data-stage]');
      this.announcement = root.querySelector('[data-announcement]');
      this.navigation = root.querySelector('[data-navigation]');
      this.nextButton = root.querySelector('[data-action="next"]');
      this.backButton = root.querySelector('[data-action="back"]');
      this.storageKey = `hood-configurator:${this.config.sectionId}`;
      this.state = this.restore() || this.freshState();
      this.fileObjects = [];
      this.previewMode = 'fallback';
      this.boundClick = this.onClick.bind(this);
      this.boundInput = this.onInput.bind(this);
      this.root.addEventListener('click', this.boundClick);
      this.root.addEventListener('input', this.boundInput);
      this.root.addEventListener('change', this.boundInput);
      this.render();
    }

    freshState() {
      return { version: STORAGE_VERSION, code: this.createCode(), index: 0, selections: {}, files: [] };
    }

    createCode() {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      const bytes = new Uint8Array(6);
      if (window.crypto?.getRandomValues) window.crypto.getRandomValues(bytes);
      else for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
      return `HD-${new Date().getFullYear()}-${Array.from(bytes, (value) => chars[value % chars.length]).join('')}`;
    }

    restore() {
      if (!this.config.storage) return null;
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey));
        return saved?.version === STORAGE_VERSION && saved.code ? saved : null;
      } catch (_) { return null; }
    }

    save() {
      if (!this.config.storage) return;
      try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.state)); } catch (_) {}
    }

    get path() {
      const family = this.state.selections.family;
      return PATHS[family] || ['family'];
    }

    get stepKey() { return this.path[Math.min(this.state.index, this.path.length - 1)]; }
    get step() { return STEP_DEFINITIONS[this.stepKey]; }

    render() {
      const path = this.path;
      if (this.state.index >= path.length) this.state.index = path.length - 1;
      const key = this.stepKey;
      const step = this.step;
      this.updateProgress();
      this.navigation.hidden = key === 'final';

      if (key === 'final') this.renderFinal();
      else {
        this.stage.innerHTML = `<div class="hood-step" data-step="${key}" aria-current="step"><header class="hood-step__heading"><h2>${step.title}</h2><p>${step.subtitle || ''}</p></header><div class="hood-step__content">${this.renderControl(key, step)}</div></div>`;
        this.backButton.disabled = this.state.index === 0;
        this.nextButton.textContent = this.state.index === path.length - 2 ? 'Vedi il tuo tavolo' : 'Avanti';
        this.updateNext();
      }
      this.save();
    }

    updateProgress() {
      const current = this.state.index + 1;
      const total = this.path.length;
      this.root.querySelector('[data-step-count]').textContent = `Passaggio ${current}/${total}`;
      const bar = this.root.querySelector('[role="progressbar"]');
      bar.setAttribute('aria-valuemax', total);
      bar.setAttribute('aria-valuenow', current);
      this.root.querySelector('[data-progress]').style.width = `${(current / total) * 100}%`;
    }

    renderControl(key, step) {
      if (step.type === 'family') return this.renderFamilies();
      if (step.type === 'cards') {
        if (key === 'resin') return this.renderResin();
        return this.renderCards(key, key === 'wood' ? this.woodOptions() : this.filteredCardOptions(step.options));
      }
      if (step.type === 'finish') return this.renderCards(key, ['microcement', 'lacquered'].includes(this.state.selections.family) ? OPTIONS.lacquerFinish : OPTIONS.woodFinish);
      if (step.type === 'color') return this.renderColor();
      if (step.type === 'base') return this.renderBases();
      if (step.type === 'baseColor') return this.renderBaseColor();
      if (step.type === 'size') return this.renderSizes();
      if (step.type === 'files') return this.renderFiles();
      if (step.type === 'text') return `<label class="hood-text-field" for="hood-delivery-${this.config.sectionId}">Provincia o località di consegna<input id="hood-delivery-${this.config.sectionId}" type="text" data-field="delivery" autocomplete="address-level2" value="${this.escape(this.state.selections.delivery || '')}" required></label>`;
      return '';
    }

    renderFamilies() {
      return `<div class="hood-card-grid hood-card-grid--families" role="radiogroup" aria-label="Famiglia del tavolo">${Object.entries(this.config.families).map(([key, item]) => this.card('family', key, item.label, item.image, item.description)).join('')}</div>`;
    }

    renderCards(field, items) {
      return `<div class="hood-card-grid" role="radiogroup" aria-label="${this.escape(STEP_DEFINITIONS[field]?.title || field)}">${items.map(([key, label, color]) => this.card(field, key, label, this.config.media[key], '', color)).join('')}</div>`;
    }

    woodOptions() { return this.state.selections.family === 'wood-resin' ? OPTIONS.resinWood : OPTIONS.solidWood; }

    filteredCardOptions(source) {
      if (source === 'edge' && ['microcement', 'lacquered'].includes(this.state.selections.family)) return OPTIONS.edge.filter(([key]) => key !== 'live-edge');
      return OPTIONS[source];
    }

    card(field, key, label, image, description = '', color = '') {
      const selected = this.state.selections[field] === key;
      const visual = image ? `<img src="${image}" alt="${this.escape(label)}" loading="lazy" width="600" height="450">` : color ? `<span class="hood-card__swatch" style="--swatch:${color}" aria-hidden="true"></span>` : `<span class="hood-card__placeholder" aria-hidden="true">${this.escape(label.charAt(0))}</span>`;
      return `<button type="button" class="hood-card${selected ? ' is-selected' : ''}" role="radio" aria-checked="${selected}" data-select="${field}" data-value="${key}"><span class="hood-card__check" aria-hidden="true">✓</span><span class="hood-card__media">${visual}</span><span class="hood-card__copy"><strong>${this.escape(label)}</strong>${description ? `<small>${this.escape(description)}</small>` : ''}</span></button>`;
    }

    renderColor() {
      const family = this.state.selections.family;
      const items = family === 'microcement' ? OPTIONS.microcementColor : OPTIONS.lacquerColor;
      const custom = this.state.selections.color === 'custom-color';
      return `${this.renderCards('color', items)}${custom ? `<label class="hood-text-field hood-text-field--compact" for="hood-color-${this.config.sectionId}">Colorazione personalizzata<input id="hood-color-${this.config.sectionId}" type="text" data-field="customColor" value="${this.escape(this.state.selections.customColor || '')}" placeholder="Descrivi il colore desiderato" required></label>` : ''}`;
    }

    renderResin() {
      const custom = this.state.selections.resin === 'custom-resin';
      return `${this.renderCards('resin', OPTIONS.resin)}${custom ? `<label class="hood-text-field hood-text-field--compact" for="hood-resin-${this.config.sectionId}">Colorazione resina personalizzata<input id="hood-resin-${this.config.sectionId}" type="text" data-field="customResin" value="${this.escape(this.state.selections.customResin || '')}" placeholder="Descrivi pigmento e tonalità" required></label>` : ''}`;
    }

    compatibleBases() {
      const { family, shape, size } = this.state.selections;
      const roundAllowed = ['round-central', 'square-central', 'base-spyder', 'trapezoid', 'base-scorpyo'];
      return OPTIONS.bases.filter((base) => {
        if (family === 'wood-resin' && ['glass-legs', 'micro-cone', 'micro-cylinder'].includes(base.key)) return false;
        if (family === 'lacquered' && base.special === 'micro') return false;
        if (shape === 'round') {
          const allowed = [...roundAllowed];
          if (family === 'solid-wood' || family === 'microcement') allowed.push('micro-cone', 'micro-cylinder', 'lacquer-cone', 'lacquer-cylinder');
          if (family === 'lacquered') allowed.push('lacquer-cone', 'lacquer-cylinder');
          return allowed.includes(base.key);
        }
        if (base.special && family === 'solid-wood' && !this.atLeast140(size)) return false;
        return true;
      });
    }

    atLeast140(size) {
      const order = ['80x80','80x120','80x140','80x160','80x180','90x200','100x220','100x240','120x240','120x300'];
      return order.indexOf(size) >= order.indexOf('80x140');
    }

    renderBases() {
      const items = this.compatibleBases().map((base) => [base.key, base.label]);
      return this.renderCards('base', items);
    }

    renderBaseColor() {
      const items = [...OPTIONS.baseColor];
      if (['microcement', 'lacquered'].includes(this.state.selections.family)) items.push(['same-as-top', 'Stesso colore del top']);
      return this.renderCards('baseColor', items);
    }

    renderSizes() {
      const items = this.state.selections.shape === 'round' ? DIMENSIONS.round : DIMENSIONS.rectangular;
      return this.renderCards('size', items);
    }

    renderDimension(key) {
      const limits = this.config.dimensions[key];
      let value = Number(this.state.selections[key]);
      if (!this.validDimension(key, value)) {
        value = limits.min;
        this.state.selections[key] = value;
        if (this.state.selections.shape === 'square') this.state.selections.width = value;
      }
      const label = LABELS[key];
      return `<div class="hood-dimension"><p class="hood-dimension__value"><span>${label}</span><strong data-dimension-value>${value} cm</strong></p><label class="visually-hidden" for="hood-range-${key}-${this.config.sectionId}">${label} in centimetri</label><input id="hood-range-${key}-${this.config.sectionId}" class="hood-dimension__range" type="range" min="${limits.min}" max="${limits.max}" step="${limits.step}" value="${value}" data-dimension="${key}"><label class="hood-dimension__number" for="hood-number-${key}-${this.config.sectionId}"><span>Inserisci il valore</span><span><input id="hood-number-${key}-${this.config.sectionId}" type="number" min="${limits.min}" max="${limits.max}" step="${limits.step}" value="${value}" data-dimension="${key}"> cm</span></label><p class="hood-field-error" data-dimension-error aria-live="polite"></p><p class="hood-dimension__limits">Da ${limits.min} a ${limits.max} cm, incrementi di ${limits.step} cm.</p>${this.state.selections.shape === 'square' ? '<p class="hood-form-note">Per la forma quadrata lunghezza e larghezza restano uguali.</p>' : ''}</div>`;
    }

    renderFiles() {
      const list = this.state.files.map((file, index) => `<li><span><strong>${this.escape(file.name)}</strong><small>${this.formatBytes(file.size)}</small></span><button type="button" data-remove-file="${index}" aria-label="Rimuovi ${this.escape(file.name)}">Rimuovi</button></li>`).join('');
      return `<div class="hood-files"><label class="hood-files__picker" for="hood-files-${this.config.sectionId}"><span>Seleziona file</span><small>JPG, JPEG, PNG o PDF — massimo 10 MB per file</small><input id="hood-files-${this.config.sectionId}" type="file" accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf" multiple data-files></label><p class="hood-field-error" data-file-error aria-live="polite"></p>${list ? `<ul class="hood-files__list">${list}</ul>` : ''}<p class="hood-form-note">${this.escape(this.config.texts.fileNotice)}</p></div>`;
    }

    renderFinal() {
      this.stage.innerHTML = '';
      const final = this.root.querySelector('[data-final-template]').content.cloneNode(true);
      const form = this.root.querySelector('[data-form-template]').content.cloneNode(true);
      this.stage.append(final, form);
      this.root.querySelectorAll('[data-code]').forEach((node) => { node.textContent = this.state.code; });
      this.root.querySelector('[data-summary]').innerHTML = this.summaryRows();
      this.renderPrice();
      this.renderPreview();
      this.fillForm();
      const success = this.root.querySelector('[data-server-success]');
      if (success) {
        try { sessionStorage.removeItem(this.storageKey); } catch (_) {}
        success.focus();
      } else {
        const download = this.root.querySelector('[data-action="download"]');
        if (download) download.hidden = true;
      }
    }

    summaryItems() {
      const s = this.state.selections;
      const ordered = ['family', 'model', 'shape', 'wood', 'size', 'edge', 'resin', 'customResin', 'color', 'customColor', 'finish', 'base', 'baseColor', 'use', 'delivery'];
      const lookup = (field, value) => {
        if (field === 'family') return this.config.families[value]?.label;
        if (field === 'base') return OPTIONS.bases.find((x) => x.key === value)?.label;
        if (field === 'wood') return [...OPTIONS.resinWood, ...OPTIONS.solidWood].find((x) => x[0] === value)?.[1];
        if (field === 'size') return [...DIMENSIONS.rectangular, ...DIMENSIONS.round].find((x) => x[0] === value)?.[1];
        const source = field === 'finish' ? [...OPTIONS.woodFinish, ...OPTIONS.lacquerFinish] : field === 'color' ? [...OPTIONS.microcementColor, ...OPTIONS.lacquerColor] : field === 'baseColor' ? OPTIONS.baseColor.concat([['same-as-top', 'Stesso colore del top']]) : OPTIONS[field];
        return source?.find((x) => x[0] === value)?.[1] || value;
      };
      const items = ordered.filter((key) => s[key] !== undefined && s[key] !== '').map((key) => ({ key, label: LABELS[key] || (key === 'customResin' ? 'Resina personalizzata' : key), value: lookup(key, s[key]) }));
      if (this.state.files.length) items.push({ key: 'files', label: LABELS.files, value: this.state.files.map((file) => file.name).join(', ') });
      return items;
    }

    summaryRows() {
      return this.summaryItems().map((item) => `<div><dt>${this.escape(item.label)}</dt><dd>${this.escape(String(item.value))}</dd></div>`).join('');
    }

    calculatePrice() {
      const s = this.state.selections;
      const sizeTable = ['microcement', 'lacquered'].includes(s.family) ? PRICE.size.modern : PRICE.size[s.family];
      const finishTable = ['microcement', 'lacquered'].includes(s.family) ? PRICE.finishModern : PRICE.finish;
      const base = OPTIONS.bases.find((item) => item.key === s.base);
      return (PRICE.wood[s.wood] || 0) + (PRICE.shape[s.shape] || 0) + (PRICE.edge[s.edge] || 0) +
        (sizeTable?.[s.size] || 0) + (finishTable[s.finish] || 0) + (base?.price || 0) + PRICE.shipping;
    }

    renderPrice() {
      const total = this.calculatePrice();
      const low = Math.round((total * .85) / 10) * 10;
      const high = Math.round((total * 1.15) / 10) * 10;
      const format = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
      const range = this.root.querySelector('[data-price-range]');
      if (range) range.textContent = `da ${format.format(low)} a ${format.format(high)}`;
      const estimate = this.root.querySelector('[data-price-estimate]');
      if (estimate) estimate.value = `${format.format(total)} — fascia ${format.format(low)} / ${format.format(high)}`;
      this.priceData = { total, low, high };
    }

    previewKeys() {
      const s = this.state.selections;
      return [s.family, s.shape, s.model, s.wood, s.resin, s.color, s.base, s.baseColor, s.finish].filter(Boolean);
    }

    renderPreview() {
      const canvas = this.root.querySelector('[data-preview-canvas]');
      const label = this.root.querySelector('[data-preview-label]');
      const keys = this.previewKeys();
      const combination = keys.join('-');
      const complete = this.config.completePreviews[combination];
      const matchedLayers = this.config.layers.filter((layer) => keys.includes(layer.match) || keys.some((key) => layer.match === `${this.state.selections.family}-${key}`));
      const order = { background: 1, shadow: 2, base: 3, top: 4, texture: 5, detail: 6, overlay: 7 };
      let images = [];

      if (complete) {
        images = [{ ...complete, type: 'complete' }];
        this.previewMode = 'immagine completa';
        label.hidden = true;
      } else if (matchedLayers.length) {
        if (this.config.previewBackground && !matchedLayers.some((layer) => layer.type === 'background')) images.push({ src: this.config.previewBackground, alt: 'Sfondo della preview', type: 'background' });
        images.push(...matchedLayers.sort((a, b) => order[a.type] - order[b.type]));
        this.previewMode = 'composizione a livelli';
        label.hidden = matchedLayers.some((layer) => ['base', 'top'].includes(layer.type));
      } else {
  this.previewMode = 'riepilogo senza immagine';
  label.hidden = true;

  const previewColumn = canvas.closest('[data-preview]').parentElement;
  const finalGrid = this.root.querySelector('.hood-configurator__final-grid');

  previewColumn.hidden = true;
  finalGrid.style.gridTemplateColumns = 'minmax(0, 72rem)';
  finalGrid.style.justifyContent = 'center';
}

      canvas.innerHTML = images.length ? images.map((image, index) => `<img src="${image.src}" alt="${this.escape(image.alt || 'Anteprima del tavolo')}" ${index ? 'loading="lazy"' : ''} data-preview-image data-layer="${image.type}">`).join('') : `<div class="hood-preview__empty"><span aria-hidden="true">H</span><p>La preview grafica sarà disponibile dopo il caricamento delle immagini nell’editor.</p></div>`;
      const natural = ['wood-resin', 'solid-wood'].includes(this.state.selections.family);
      this.root.querySelector('[data-preview-warning]').textContent = natural ? this.config.texts.natural : this.config.texts.finished;
      const download = this.root.querySelector('[data-action="download"]');
      download.hidden = !this.config.download || !images.length;
      download.dataset.ready = 'false';
      Promise.all(Array.from(canvas.querySelectorAll('img')).map((img) => this.imageReady(img))).then(() => { download.dataset.ready = 'true'; }).catch(() => { download.hidden = true; });
    }

    fillForm() {
      const summaryText = this.summaryItems().map((item) => `${item.label}: ${item.value}`).join('\n');
      const set = (selector, value) => { const input = this.root.querySelector(selector); if (input) input.value = value; };
      set('[data-form-code]', this.state.code);
      set('[data-form-summary]', summaryText);
      set('[data-form-preview]', this.previewMode);
      set('[data-form-url]', window.location.href);
      const price = this.priceData ? `\nStima interna: € ${this.priceData.total}\nFascia mostrata: € ${this.priceData.low} / € ${this.priceData.high}` : '';
      set('[data-form-body]', `È RICHIESTA UN’OFFERTA PERSONALIZZATA\n\nCodice: ${this.state.code}\n${summaryText}${price}\nModalità preview: ${this.previewMode}\nPagina: ${window.location.href}`);
    }

    imageReady(img) {
      if (img.complete) return img.naturalWidth ? Promise.resolve() : Promise.reject(new Error('image'));
      return new Promise((resolve, reject) => { img.addEventListener('load', resolve, { once: true }); img.addEventListener('error', reject, { once: true }); });
    }

    async downloadPreview() {
      const images = Array.from(this.root.querySelectorAll('[data-preview-image]'));
      if (!images.length) return;
      const canvas = document.createElement('canvas');
      canvas.width = 1600; canvas.height = 1000;
      const context = canvas.getContext('2d');
      context.fillStyle = '#f4f2ed'; context.fillRect(0, 0, canvas.width, canvas.height);
      try {
        for (const source of images) {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.src = source.currentSrc || source.src;
          await this.imageReady(image);
          const scale = Math.min(canvas.width / image.naturalWidth, canvas.height / image.naturalHeight);
          const width = image.naturalWidth * scale, height = image.naturalHeight * scale;
          context.drawImage(image, (canvas.width - width) / 2, (canvas.height - height) / 2, width, height);
        }
        const link = document.createElement('a');
        link.download = `${this.state.code.toLowerCase()}-anteprima.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
      } catch (_) {
        const button = this.root.querySelector('[data-action="download"]');
        button.hidden = true;
        this.say('Il browser non consente di esportare queste immagini. La richiesta di preventivo può essere inviata normalmente.');
      }
    }

    onClick(event) {
      const select = event.target.closest('[data-select]');
      if (select) { this.select(select.dataset.select, select.dataset.value); return; }
      const remove = event.target.closest('[data-remove-file]');
      if (remove) { this.removeFile(Number(remove.dataset.removeFile)); return; }
      const action = event.target.closest('[data-action]')?.dataset.action;
      if (action === 'next') this.next();
      if (action === 'back') this.back();
      if (action === 'restart') this.restart();
      if (action === 'edit') { this.state.index = 0; this.render(); this.focusStage(); }
      if (action === 'download') this.downloadPreview();
    }

    onInput(event) {
      const dimension = event.target.dataset.dimension;
      if (dimension) {
        const value = Number(event.target.value);
        this.state.selections[dimension] = value;
        if (this.state.selections.shape === 'square') {
          this.state.selections.length = value;
          this.state.selections.width = value;
        }
        this.root.querySelectorAll(`[data-dimension="${dimension}"]`).forEach((input) => { if (input !== event.target) input.value = event.target.value; });
        this.root.querySelector('[data-dimension-value]').textContent = `${value} cm`;
        const error = this.validDimension(dimension, value) ? '' : `Inserisci un valore tra ${this.config.dimensions[dimension].min} e ${this.config.dimensions[dimension].max} cm rispettando gli incrementi previsti.`;
        this.root.querySelector('[data-dimension-error]').textContent = error;
        this.updateNext(); this.save(); return;
      }
      if (event.target.dataset.field) {
        this.state.selections[event.target.dataset.field] = event.target.value.trim();
        this.updateNext(); this.save();
      }
      if (event.target.matches('[data-files]')) this.addFiles(event.target.files);
    }

    select(field, value) {
      const previous = this.state.selections[field];
      this.state.selections[field] = value;
      if (field === 'family' && previous && previous !== value) this.clearIncompatibleForFamily();
      if (field === 'shape') {
        delete this.state.selections.size;
        this.invalidateBase();
      }
      if (field === 'size') this.invalidateBase();
      if (field === 'model') this.applyModelShape(value);
      if (field === 'color' && value !== 'custom-color') delete this.state.selections.customColor;
      if (field === 'resin' && value !== 'custom-resin') delete this.state.selections.customResin;
      this.render();
    }

    applyModelShape(model) {
      if (model.startsWith('round-')) this.state.selections.shape = 'round';
      if (model.startsWith('rectangular-')) this.state.selections.shape = 'rectangular';
      if (model.startsWith('oval-')) this.state.selections.shape = 'oval';
      this.invalidateBase();
    }

    clearIncompatibleForFamily() {
      const keep = ['family', 'delivery'];
      Object.keys(this.state.selections).forEach((key) => { if (!keep.includes(key)) delete this.state.selections[key]; });
      this.say('Il percorso è stato aggiornato per la nuova famiglia. Le sole scelte non compatibili sono state rimosse.');
    }

    invalidateBase() {
      if (this.state.selections.base && !this.compatibleBases().some((base) => base.key === this.state.selections.base)) {
        delete this.state.selections.base;
        this.say('La base scelta non è compatibile con la nuova forma ed è stata rimossa.');
      }
    }

    next() {
      if (!this.isValid()) return;
      this.state.index = Math.min(this.state.index + 1, this.path.length - 1);
      this.render(); this.focusStage();
    }

    back() {
      this.state.index = Math.max(this.state.index - 1, 0);
      this.render(); this.focusStage();
    }

    restart() {
      if (!window.confirm('Vuoi cancellare tutte le scelte e ricominciare?')) return;
      try { sessionStorage.removeItem(this.storageKey); } catch (_) {}
      this.state = this.freshState(); this.fileObjects = [];
      this.render(); this.say('Configurazione cancellata. Puoi iniziare un nuovo progetto.'); this.focusStage();
    }

    isValid() {
      const key = this.stepKey;
      if (!this.step.required) return true;
      if (['length', 'width', 'diameter'].includes(key)) return this.validDimension(key, Number(this.state.selections[key]));
      if (key === 'color' && this.state.selections.color === 'custom-color') return Boolean(this.state.selections.customColor?.trim());
      if (key === 'resin' && this.state.selections.resin === 'custom-resin') return Boolean(this.state.selections.customResin?.trim());
      return Boolean(this.state.selections[key]);
    }

    validDimension(key, value) {
      const limits = this.config.dimensions[key];
      if (!Number.isFinite(value) || value < limits.min || value > limits.max) return false;
      return Math.abs((value - limits.min) % limits.step) < 0.001;
    }

    updateNext() { this.nextButton.disabled = !this.isValid(); }

    addFiles(fileList) {
      const allowed = ['image/jpeg', 'image/png', 'application/pdf'];
      const max = 10 * 1024 * 1024;
      const error = this.root.querySelector('[data-file-error]');
      let message = '';
      Array.from(fileList).forEach((file) => {
        if (!allowed.includes(file.type)) { message = `${file.name}: formato non supportato.`; return; }
        if (file.size > max) { message = `${file.name}: il file supera 10 MB.`; return; }
        if (!this.state.files.some((item) => item.name === file.name && item.size === file.size)) {
          this.state.files.push({ name: file.name, size: file.size, type: file.type });
          this.fileObjects.push(file);
        }
      });
      if (error) error.textContent = message;
      this.render();
    }

    removeFile(index) {
      this.state.files.splice(index, 1); this.fileObjects.splice(index, 1); this.render();
    }

    focusStage() { requestAnimationFrame(() => this.stage.querySelector('h2, [tabindex="-1"]')?.focus({ preventScroll: true })); }
    say(message) { this.announcement.textContent = ''; requestAnimationFrame(() => { this.announcement.textContent = message; }); }
    escape(value) { const node = document.createElement('div'); node.textContent = value ?? ''; return node.innerHTML; }
    formatBytes(bytes) { return bytes < 1024 * 1024 ? `${Math.round(bytes / 1024)} KB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`; }

    destroy() {
      this.root.removeEventListener('click', this.boundClick);
      this.root.removeEventListener('input', this.boundInput);
      this.root.removeEventListener('change', this.boundInput);
      this.root.dataset.initialized = 'false';
    }
  }

  const instances = new Map();
  const init = (scope = document) => scope.querySelectorAll(SELECTORS.root).forEach((root) => {
    if (!instances.has(root)) instances.set(root, new HoodConfigurator(root));
  });
  const unload = (sectionId) => {
    const root = document.querySelector(`#HoodConfigurator-${CSS.escape(sectionId)}`);
    const instance = root && instances.get(root);
    if (instance) { instance.destroy(); instances.delete(root); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.detail.sectionId));
  document.addEventListener('shopify:section:select', (event) => {
    init(event.target);
    event.target.querySelector(SELECTORS.root)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
